import { render, staticRenderFns } from "./AddManufacturingLogbookKpiBartrendWidget.vue?vue&type=template&id=04532490"
import script from "./AddManufacturingLogbookKpiBartrendWidget.vue?vue&type=script&lang=js"
export * from "./AddManufacturingLogbookKpiBartrendWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports